var _polygon, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.45,292.8c-15.48-13.28-17.1-35.23-14.51-54.55.43-3.23.42-6.68,2.24-9.36s5.61-4.27,8.37-2.62c2.29,1.37,3.06,4.27,4.18,6.72a19.06,19.06,0,0,0,6.86,8c2,1.27,4.44,2.18,6.59,1.26,3-1.26,3.66-5.09,4-8.31l1.68-18c.3-3.22.62-6.51,1.93-9.46s3.8-5.57,7-6.13,6.76,1.59,7.09,4.81a30.36,30.36,0,0,1-.31,4c0,1.34.43,2.88,1.66,3.38s2.63-.28,3.69-1.12c3.64-2.92,6.31-6.88,8.84-10.84s5-8,8.36-11.26,7.82-5.63,12.45-5.44,9.27,3.54,10,8.18-2.39,9-5.64,12.38a71.85,71.85,0,0,1-16.38,12.77,6,6,0,0,0-2.77,2.44c-.91,2.08.91,4.41,3,5.33,2.32,1,4.94,1.05,7.42,1.6s5.09,1.92,5.81,4.39c1,3.42-2.11,6.59-5,8.58a61.86,61.86,0,0,1-19.27,8.7c-2.45.63-5,1.14-7.1,2.62s-3.51,4.25-2.59,6.63,3.82,3.41,6.35,3.19,4.88-1.33,7.33-2c4.59-1.23,10.27-.35,12.73,3.75,1.61,2.7,1.42,6.22.18,9.12a23.58,23.58,0,0,1-5.67,7.47A62.3,62.3,0,0,1,647.5,295c-10.62,2.53-20.23,2.55-30-2.2",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.67,281.14a289.21,289.21,0,0,1,14.54-29.91c1.43-2.58,2.83-5.13,4.22-7.65s2.77-5,4.26-7.34a146.66,146.66,0,0,1,9.38-13c3.19-4,6.35-7.66,9.34-11.07s5.84-6.53,8.56-9.26A116.75,116.75,0,0,1,687.75,191c1.73-1.27,3.11-2.22,4-2.85l1.07-.71.38-.22a2.28,2.28,0,0,1-.34.28l-1,.75c-.92.66-2.27,1.64-4,2.94a122,122,0,0,0-13.62,12.05c-2.69,2.74-5.52,5.87-8.49,9.29s-6.12,7.1-9.28,11.08a146.89,146.89,0,0,0-9.32,13c-1.48,2.34-2.84,4.8-4.24,7.32l-4.21,7.64a298.06,298.06,0,0,0-14.56,29.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.87,236.24a5.48,5.48,0,0,1-.18-1.41c-.08-.9-.16-2.22-.22-3.84-.14-3.25-.17-7.75-.19-12.71s-.12-9.44-.3-12.68c-.09-1.62-.17-2.93-.24-3.83a6.17,6.17,0,0,1,0-1.42,7,7,0,0,1,.27,1.39c.14.9.29,2.21.43,3.83.29,3.25.46,7.75.47,12.71s0,9.31,0,12.7c0,1.52,0,2.81,0,3.84A7.22,7.22,0,0,1,646.87,236.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,232.63a9.21,9.21,0,0,1-1.68,0c-1.07,0-2.62,0-4.53,0-3.83,0-9.13.26-15,.77s-11.08,1.21-14.87,1.82c-1.9.29-3.42.57-4.48.75a9.45,9.45,0,0,1-1.65.24,8.42,8.42,0,0,1,1.6-.47c1-.25,2.57-.59,4.46-.94,3.78-.72,9-1.49,14.89-2a148.52,148.52,0,0,1,15-.59c1.92,0,3.47.12,4.55.2A9.19,9.19,0,0,1,689,232.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.25,280.43a1.82,1.82,0,0,1-.23-.53c-.15-.42-.34-.94-.56-1.57-.48-1.36-1.12-3.35-1.88-5.82-1.53-4.94-3.42-11.83-5.4-19.47s-3.81-14.53-5.23-19.5c-.69-2.41-1.27-4.4-1.7-5.87l-.45-1.6a2,2,0,0,1-.12-.58,2.46,2.46,0,0,1,.24.54l.55,1.57c.48,1.36,1.13,3.35,1.89,5.82,1.52,4.94,3.41,11.83,5.39,19.47s3.81,14.53,5.23,19.49l1.7,5.88.45,1.6A2.08,2.08,0,0,1,624.25,280.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681,268.19a2.38,2.38,0,0,1-.57.17l-1.65.38-6.08,1.32c-5.14,1.12-12.21,2.74-20,4.55S637.79,278,632.63,279c-2.58.51-4.67.9-6.12,1.14l-1.67.26a1.88,1.88,0,0,1-.59.05,2.19,2.19,0,0,1,.57-.17l1.65-.37,6.08-1.32c5.13-1.12,12.21-2.75,20-4.55s14.91-3.37,20.06-4.38c2.58-.5,4.67-.89,6.13-1.13l1.67-.27A2.36,2.36,0,0,1,681,268.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.75,152.2a9.09,9.09,0,0,1-10.65-11.56l15.54-50a9,9,0,0,1,6.67-6.17h0a9,9,0,0,1,8.65,2.7l35.53,38.45a9.08,9.08,0,0,1-4.67,15L654.78,152.2Zm12.18-65.09h0a6.29,6.29,0,0,0-4.68,4.32l-15.54,50a6.38,6.38,0,0,0,7.47,8.11h0L705.25,138a6.37,6.37,0,0,0,3.28-10.54L673,89A6.29,6.29,0,0,0,666.93,87.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.44,133a3.34,3.34,0,0,1,2.67-4,3.31,3.31,0,0,1,4.09,2.48,3.36,3.36,0,0,1-2.58,4.07A3.39,3.39,0,0,1,673.44,133Zm-5.83-26.65,6.25-1.44,3.5,20-4.18,1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.82,291.62s-6.44,3.62,3.25,17,16,19.83,16,19.83,1.84,3.17-.92,4.14-9.19.94-9.92,4.62,2.4,6.82,8.18,9,18.28,7.38,19.41,7.85,2.37,1.88.59,2.84S63.72,361.54,65.85,368s19.23,9.86,21.1,10.27,2.4,1.08,2.4,2.07-4.77,1.78-8.67,3-8.22,3.28-6.68,6.91,12.37,10.1,36,8.77l10.91-1.33,4.49-10.09c8.29-22.19,5.34-34.44,2.32-37s-6.28.95-8.58,4.32-4.48,7.7-5.42,7.4-1.43-1-1.27-2.91,2-19.24-3.54-23.2-13.16,8.21-14.61,9.62-2.42-.21-2.54-1.41-1.38-14.7-1.73-20.86-2.28-10.07-6.15-10.48-5.61,5.74-7.35,8.09-4.23-.34-4.23-.34S68,313,58.11,299.71s-15.41-8-15.41-8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,400.16c-7.25-9.75-19.86-27.3-30.76-42.31s-20.78-28.57-28-38.36l-8.55-11.58-2.32-3.15-.6-.83c-.13-.18-.19-.28-.19-.28a3.08,3.08,0,0,1,.22.26c.15.19.36.46.62.81.56.72,1.35,1.77,2.38,3.11,2.06,2.7,5,6.64,8.63,11.52,7.26,9.75,17.17,23.3,28.07,38.3s23.47,32.58,30.68,42.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.17,337.65a3.75,3.75,0,0,1,.79.09c.51.08,1.24.22,2.13.4,1.79.36,4.25.92,7,1.58L77,341.45l2.1.51a3.74,3.74,0,0,1,.76.22,3.12,3.12,0,0,1-.79-.09c-.5-.08-1.23-.21-2.12-.4-1.79-.38-4.25-1-7-1.64L63,338.37l-2.1-.5A4,4,0,0,1,60.17,337.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.47,341.37c-.09,0,.83-5.14,2.07-11.45s2.32-11.4,2.41-11.38-.83,5.14-2.07,11.45S80.56,341.39,80.47,341.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,365.17a4.11,4.11,0,0,1,.33-.74l1-2c.85-1.65,2-4,3.22-6.52s2.21-4.94,2.92-6.66c.34-.81.63-1.49.85-2a4.13,4.13,0,0,1,.35-.73,4.19,4.19,0,0,1-.22.78c-.17.49-.42,1.21-.75,2.08-.66,1.74-1.64,4.13-2.84,6.71s-2.41,4.87-3.32,6.5c-.46.81-.84,1.46-1.11,1.91A3.88,3.88,0,0,1,96.17,365.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,365.84a4.14,4.14,0,0,1,.74-.1l2-.15c1.72-.11,4.09-.25,6.72-.37s5-.22,6.72-.28l2,0a3.71,3.71,0,0,1,.75,0,3.23,3.23,0,0,1-.74.1l-2,.15c-1.72.12-4.09.25-6.72.38s-5,.22-6.72.27l-2,0A2.47,2.47,0,0,1,77.07,365.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,388.61a6.43,6.43,0,0,1,.95-.12l2.61-.2c2.2-.16,5.24-.36,8.61-.55s6.41-.35,8.61-.45l2.61-.09a5.08,5.08,0,0,1,1,0,4.72,4.72,0,0,1-1,.12l-2.61.21c-2.2.15-5.24.35-8.6.54s-6.41.35-8.62.45l-2.61.09A4.18,4.18,0,0,1,88.26,388.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,387.08a6.62,6.62,0,0,1,.41-.95c.3-.65.71-1.5,1.19-2.53,1-2.14,2.39-5.1,3.82-8.4s2.66-6.34,3.53-8.54c.41-1.05.76-1.93,1-2.6a5.34,5.34,0,0,1,.41-.94,5.68,5.68,0,0,1-.29,1c-.21.63-.52,1.54-.93,2.65-.81,2.22-2,5.27-3.44,8.58s-2.85,6.26-3.91,8.38c-.54,1.05-1,1.9-1.3,2.48A5.8,5.8,0,0,1,112,387.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.58,
    y: 87.39,
    width: 104.14,
    height: 319.03,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 87.39,
    width: 82.31,
    height: 319.03,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 138.45,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 141.57,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,145.58a1.58,1.58,0,1,1-1.57-1.57A1.57,1.57,0,0,1,135.41,145.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,152.3a1.58,1.58,0,1,1-1.57-1.57A1.58,1.58,0,0,1,135.41,152.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 144.01,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 178.28,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 181.41,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,185.42a1.58,1.58,0,1,1-1.57-1.58A1.58,1.58,0,0,1,135.41,185.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.84,
    cy: 192.14,
    r: 1.57,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 183.84,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 218.12,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 221.25,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,225.25a1.58,1.58,0,1,1-1.57-1.57A1.58,1.58,0,0,1,135.41,225.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.84,
    cy: 231.98,
    r: 1.57,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 223.68,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 257.96,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 261.09,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,265.09a1.58,1.58,0,1,1-1.57-1.57A1.57,1.57,0,0,1,135.41,265.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,271.82a1.58,1.58,0,1,1-1.57-1.58A1.57,1.57,0,0,1,135.41,271.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 263.52,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 297.8,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 300.92,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,304.93a1.58,1.58,0,1,1-1.57-1.57A1.57,1.57,0,0,1,135.41,304.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.84,
    cy: 311.65,
    r: 1.57,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 303.36,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 337.64,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 340.76,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,344.77a1.58,1.58,0,1,1-1.57-1.58A1.58,1.58,0,0,1,135.41,344.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,351.49a1.58,1.58,0,1,1-1.57-1.57A1.57,1.57,0,0,1,135.41,351.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 343.19,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 377.47,
    width: 88.34,
    height: 24.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.63,
    y: 380.6,
    width: 4.95,
    height: 19.04,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,384.6a1.58,1.58,0,1,1-1.57-1.57A1.58,1.58,0,0,1,135.41,384.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.84,
    cy: 391.33,
    r: 1.57,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.69,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.71,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.74,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.76,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.78,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.82,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.87,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.89,
    y: 383.03,
    width: 4.86,
    height: 14.62,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,138.45a3.48,3.48,0,0,1-.1-.77c0-.51-.06-1.25-.09-2.21s-.05-2.13-.11-3.49a22.4,22.4,0,0,0-.61-4.53,16.25,16.25,0,0,0-2.36-5,11,11,0,0,0-4.83-3.89,23.55,23.55,0,0,0-6.86-1.39l-7.61-.65c-10.42-.91-19.88-1.49-26.73-1.62-3.43-.08-6.2-.06-8.12,0h-2.21a3.85,3.85,0,0,1-.77,0,3.34,3.34,0,0,1,.77-.1l2.2-.13c1.92-.09,4.7-.17,8.13-.15,6.87,0,16.35.52,26.79,1.43l7.61.67a23.71,23.71,0,0,1,7,1.47,11.41,11.41,0,0,1,5,4.12,16.58,16.58,0,0,1,2.37,5.15,21.94,21.94,0,0,1,.52,4.64c0,1.36,0,2.54,0,3.5s0,1.63,0,2.21A3.85,3.85,0,0,1,176.8,138.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,138.45a3.47,3.47,0,0,1-.06-.73c0-.54,0-1.23,0-2.08s0-2-.11-3.27a10.09,10.09,0,0,0-1.09-4.09,7.79,7.79,0,0,0-4-3,11,11,0,0,0-5.8-.59,9.9,9.9,0,0,0-3,1,5.7,5.7,0,0,0-2.32,2.19,3.12,3.12,0,0,0,0,3.09,4.13,4.13,0,0,0,2.62,2,3.32,3.32,0,0,0,3.07-.89,4.41,4.41,0,0,0,.46-5.92,6.49,6.49,0,0,0-2.32-2,8.51,8.51,0,0,0-2.91-.75q-1.5-.22-2.91-.39c-1.88-.21-3.63-.33-5.24-.4-3.22-.13-5.83-.08-7.63-.09h-2.08a2.94,2.94,0,0,1-.73,0,3.2,3.2,0,0,1,.72-.08l2.08-.12c1.8-.07,4.42-.18,7.65-.11,1.62,0,3.39.13,5.29.32,1,.1,1.92.22,2.93.36.5.08,1,.14,1.53.24a6,6,0,0,1,1.57.54,7.25,7.25,0,0,1,2.55,2.23,5.05,5.05,0,0,1,1,3.4,5.17,5.17,0,0,1-1.56,3.34,4,4,0,0,1-3.65,1,4.77,4.77,0,0,1-3-2.28,3.76,3.76,0,0,1,0-3.69,6.27,6.27,0,0,1,2.57-2.44,10.6,10.6,0,0,1,3.19-1.06,11.47,11.47,0,0,1,6.1.67,8.24,8.24,0,0,1,4.18,3.33,10.24,10.24,0,0,1,1,4.28c.07,1.3,0,2.4,0,3.31s-.07,1.53-.09,2.07A3,3,0,0,1,150,138.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,138.45a4.78,4.78,0,0,1-.18-.82c-.1-.55-.26-1.34-.48-2.36a45,45,0,0,0-2.61-8.42,24.62,24.62,0,0,0-7.68-10.31,14.44,14.44,0,0,0-7-2.67,73.79,73.79,0,0,0-8.28-.44c-11.42-.22-21.77-.18-29.25-.48-3.75-.13-6.77-.31-8.86-.46l-2.4-.21a3.19,3.19,0,0,1-.84-.12,4.9,4.9,0,0,1,.84,0l2.41.09c2.09.08,5.12.19,8.86.26,7.48.18,17.82.07,29.25.29a71.35,71.35,0,0,1,8.36.46,14.94,14.94,0,0,1,7.29,2.82,22.42,22.42,0,0,1,4.87,5.15,29.75,29.75,0,0,1,2.88,5.45,42.64,42.64,0,0,1,2.44,8.55c.18,1,.3,1.84.35,2.39A4.39,4.39,0,0,1,184,138.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.38,
    y: 91.36,
    width: 85.91,
    height: 12.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.28,
    y: 97.59,
    width: 46.78,
    height: 6.24,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Servers--inject-139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.84,
    y: 285.58,
    width: 138.56,
    height: 98.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.61,
    y: 275.44,
    width: 151.47,
    height: 37.58,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.58,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,298.58,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.13,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,306.13,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,313.68,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,321.23,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.73,285.58a1.71,1.71,0,1,1-1.71-1.71A1.7,1.7,0,0,1,379.73,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,285.58a1.71,1.71,0,1,1-1.71-1.71A1.7,1.7,0,0,1,387.43,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.78,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,328.78,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.86,285.58a1.72,1.72,0,1,1-1.72-1.71A1.71,1.71,0,0,1,365.86,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,336.33,285.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,343.88,285.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,285.58a1.72,1.72,0,1,1-1.72-1.71A1.71,1.71,0,0,1,359.2,285.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,285.58a1.72,1.72,0,1,1-1.72-1.71A1.71,1.71,0,0,1,393.7,285.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.43,285.58a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,351.43,285.58Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,285.58a1.71,1.71,0,1,1-1.71-1.71A1.7,1.7,0,0,1,373,285.58Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.27,293.83a1.72,1.72,0,1,1,1.71,1.71A1.71,1.71,0,0,1,390.27,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.43,
    cy: 293.83,
    r: 1.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.17,293.83a1.72,1.72,0,1,1,1.72,1.71A1.71,1.71,0,0,1,375.17,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,293.83a1.72,1.72,0,1,1,1.72,1.71A1.71,1.71,0,0,1,367.62,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,293.83a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,309.12,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.42,293.83a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,301.42,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.79,
    cy: 293.83,
    r: 1.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.71,
    cy: 293.83,
    r: 1.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,293.83a1.72,1.72,0,1,1,1.72,1.71A1.71,1.71,0,0,1,352.52,293.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,293.83a1.71,1.71,0,1,1,1.71,1.71A1.7,1.7,0,0,1,345,293.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.66,293.83a1.71,1.71,0,1,1,1.71,1.71A1.7,1.7,0,0,1,329.66,293.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.16,293.83a1.71,1.71,0,1,1,1.71,1.71A1.7,1.7,0,0,1,295.16,293.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.43,293.83a1.71,1.71,0,1,1,1.71,1.71A1.7,1.7,0,0,1,337.43,293.83Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.81,293.83a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,315.81,293.83Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.58,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,298.58,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.13,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,306.13,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,313.68,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.23,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,321.23,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.73,301.16a1.71,1.71,0,1,1-1.71-1.71A1.7,1.7,0,0,1,379.73,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.43,301.16a1.71,1.71,0,1,1-1.71-1.71A1.7,1.7,0,0,1,387.43,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.78,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,328.78,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.86,301.16a1.72,1.72,0,1,1-1.72-1.71A1.71,1.71,0,0,1,365.86,301.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,336.33,301.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,343.88,301.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,301.16a1.72,1.72,0,1,1-1.72-1.71A1.71,1.71,0,0,1,359.2,301.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,301.16a1.72,1.72,0,1,1-1.72-1.71A1.71,1.71,0,0,1,393.7,301.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.43,301.16a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,351.43,301.16Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,301.16a1.71,1.71,0,1,1-1.71-1.71A1.7,1.7,0,0,1,373,301.16Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 283.18,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 291.08,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 299.24,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.61,
    y: 321.82,
    width: 151.47,
    height: 37.58,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 329.56,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 337.45,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 345.62,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,298,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.58,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,305.58,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,313.13,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,320.68,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,332a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,379.18,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88,332a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,386.88,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.23,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,328.23,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31,332a1.72,1.72,0,1,1-1.71-1.71A1.72,1.72,0,0,1,365.31,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,335.78,332Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,343.33,332Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,358.65,332Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.15,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,393.15,332Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.88,332a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,350.88,332Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,332a1.72,1.72,0,1,1-1.72-1.71A1.72,1.72,0,0,1,372.5,332Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.73,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,389.73,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.18,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,382.18,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,374.63,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.08,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,367.08,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.57,340.2a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,308.57,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,340.2a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,300.87,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.53,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,359.53,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.45,340.2a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,322.45,340.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,352,340.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,344.43,340.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11,340.2a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,329.11,340.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.61,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,294.61,340.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.88,340.2a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,336.88,340.2Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.26,340.2a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,315.26,340.2Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,298,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.58,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,305.58,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,313.13,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,320.68,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,347.54a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,379.18,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88,347.54a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,386.88,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.23,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,328.23,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.31,347.54a1.72,1.72,0,1,1-1.71-1.71A1.72,1.72,0,0,1,365.31,347.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,335.78,347.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,343.33,347.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,358.65,347.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.15,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,393.15,347.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.88,347.54a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,350.88,347.54Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.5,347.54a1.72,1.72,0,1,1-1.72-1.71A1.72,1.72,0,0,1,372.5,347.54Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.85 312.67 402.08 312.73 402.08 275.15 424.85 275.09 424.85 312.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.85 359.34 402.08 359.4 402.08 321.82 424.85 321.76 424.85 359.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.45 406.36 400.68 406.42 400.68 368.84 423.45 368.77 423.45 406.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.31,
    y: 368.84,
    width: 151.47,
    height: 37.58,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.03,
    y: 376.58,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.03,
    y: 384.47,
    width: 29.82,
    height: 4.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.65,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,298.65,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.2,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,306.2,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,313.75,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,321.3,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.8,379.35a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,379.8,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,387.5,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.85,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,328.85,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,379.35a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,365.92,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,379.35a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,336.4,379.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,379.35a1.72,1.72,0,1,1-1.71-1.71A1.72,1.72,0,0,1,344,379.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,379.35a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,359.26,379.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.76,379.35a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,393.76,379.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,379.35a1.72,1.72,0,1,1-1.71-1.71A1.72,1.72,0,0,1,351.5,379.35Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.11,379.35a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,373.11,379.35Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.34,387.6a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,390.34,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,387.6a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,382.79,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.24,387.6a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,375.24,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.69,387.6a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,367.69,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.19,387.6a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,309.19,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.49,387.6a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,301.49,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.14,387.6a1.71,1.71,0,1,1,1.71,1.71A1.72,1.72,0,0,1,360.14,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.07,387.6a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,323.07,387.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.59,387.6a1.72,1.72,0,1,1,1.71,1.71A1.72,1.72,0,0,1,352.59,387.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,387.6a1.72,1.72,0,1,1,1.71,1.71A1.72,1.72,0,0,1,345,387.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,387.6a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,329.73,387.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.23,387.6a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,295.23,387.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.49,387.6a1.72,1.72,0,1,1,1.71,1.71A1.72,1.72,0,0,1,337.49,387.6Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.88,387.6a1.71,1.71,0,1,1,1.71,1.71A1.71,1.71,0,0,1,315.88,387.6Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.65,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,298.65,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.2,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,306.2,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,313.75,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,321.3,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.8,394.93a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,379.8,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,387.5,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.85,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,328.85,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,394.93a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,365.92,394.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,394.93a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,336.4,394.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,394.93a1.72,1.72,0,1,1-1.71-1.71A1.72,1.72,0,0,1,344,394.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,394.93a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,359.26,394.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.76,394.93a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,393.76,394.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,394.93a1.72,1.72,0,1,1-1.71-1.71A1.72,1.72,0,0,1,351.5,394.93Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.11,394.93a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,373.11,394.93Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.16,
    y: 63.44,
    width: 111.96,
    height: 342.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.45 406.42 542.12 406.42 541.96 63.44 630.45 63.44 630.45 406.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 118.33,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 121.7,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,126a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,126Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,133.23a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,133.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 124.31,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 156.75,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 160.11,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,164.41a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,164.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,171.64A1.69,1.69,0,1,1,448.9,170,1.69,1.69,0,0,1,450.59,171.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 162.72,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 195.47,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 198.83,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,203.13a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,203.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,210.36a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,210.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 201.44,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 237.29,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 240.66,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,245a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,245Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,252.19a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,252.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 243.27,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 279.53,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 282.9,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,287.2a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,287.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,294.43a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,294.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 285.51,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 363.6,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 366.96,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,371.27a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,371.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,378.5a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,378.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 369.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.36,
    y: 321.6,
    width: 94.97,
    height: 26.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.01,
    y: 324.97,
    width: 5.32,
    height: 20.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,329.27a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,329.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.59,336.5a1.69,1.69,0,1,1-1.69-1.69A1.69,1.69,0,0,1,450.59,336.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.35,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.45,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.99,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.54,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.09,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.64,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.19,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.74,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.29,
    y: 327.58,
    width: 5.23,
    height: 15.72,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.09,118.33a4.26,4.26,0,0,1-.09-.82c0-.54-.07-1.35-.1-2.38s0-2.29-.11-3.75a24,24,0,0,0-.65-4.88,17.59,17.59,0,0,0-2.54-5.35A11.87,11.87,0,0,0,486.4,97a25.14,25.14,0,0,0-7.39-1.5l-8.18-.71c-11.21-1-21.37-1.6-28.74-1.73-3.69-.08-6.67,0-8.73,0L431,93a4.36,4.36,0,0,1-.83,0,3.14,3.14,0,0,1,.82-.1l2.38-.14c2.06-.08,5-.17,8.73-.15,7.39,0,17.58.58,28.8,1.56l8.18.72a25.36,25.36,0,0,1,7.54,1.57,12.37,12.37,0,0,1,5.4,4.41,17.62,17.62,0,0,1,2.54,5.53,23.54,23.54,0,0,1,.58,5c0,1.47,0,2.73,0,3.76s0,1.77,0,2.38A4.29,4.29,0,0,1,495.09,118.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.28,118.33a3.81,3.81,0,0,1-.06-.77c0-.58,0-1.32,0-2.24s0-2.16-.11-3.52a10.88,10.88,0,0,0-1.17-4.41,8.49,8.49,0,0,0-4.29-3.3,11.77,11.77,0,0,0-6.26-.64,10.66,10.66,0,0,0-3.23,1.1,6.12,6.12,0,0,0-2.51,2.38,3.39,3.39,0,0,0,0,3.35,4.46,4.46,0,0,0,2.85,2.14,3.59,3.59,0,0,0,3.33-1,4.93,4.93,0,0,0,1.5-3.17,4.76,4.76,0,0,0-1-3.25,6.92,6.92,0,0,0-2.51-2.22,9.33,9.33,0,0,0-3.14-.81c-1.07-.16-2.11-.3-3.12-.41-2-.23-3.91-.36-5.64-.43-3.46-.13-6.27-.08-8.21-.08h-2.23a4.19,4.19,0,0,1-.78,0,3.55,3.55,0,0,1,.77-.08l2.23-.11c1.94-.08,4.75-.2,8.23-.12,1.74.05,3.64.15,5.68.36,1,.1,2.07.23,3.15.38.54.09,1.08.16,1.64.26a6.44,6.44,0,0,1,1.68.58,7.79,7.79,0,0,1,2.73,2.39,5.41,5.41,0,0,1,1.11,3.62,5.56,5.56,0,0,1-1.67,3.57,4.24,4.24,0,0,1-3.88,1.11,5,5,0,0,1-3.24-2.44,4,4,0,0,1,0-3.92,6.69,6.69,0,0,1,2.76-2.6,11.09,11.09,0,0,1,3.41-1.15,12.23,12.23,0,0,1,6.53.73,8.73,8.73,0,0,1,4.48,3.55,11,11,0,0,1,1.14,4.6c.07,1.38,0,2.57,0,3.54s-.07,1.66-.09,2.24A4.17,4.17,0,0,1,466.28,118.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.84,118.33a5.58,5.58,0,0,1-.19-.88c-.1-.58-.26-1.44-.5-2.54a49.06,49.06,0,0,0-2.79-9.06,26.37,26.37,0,0,0-8.27-11.09,15.57,15.57,0,0,0-7.58-2.89,79.68,79.68,0,0,0-8.9-.48c-12.27-.23-23.4-.18-31.45-.49-4-.14-7.27-.33-9.52-.49l-2.58-.21a5.48,5.48,0,0,1-.9-.12,5.62,5.62,0,0,1,.9,0l2.59.11c2.25.08,5.5.21,9.52.29,8.05.2,19.16.09,31.45.32a77.33,77.33,0,0,1,9,.5,16.14,16.14,0,0,1,7.83,3,24,24,0,0,1,5.22,5.53,32.34,32.34,0,0,1,3.1,5.85,45.61,45.61,0,0,1,2.63,9.18c.2,1.1.33,2,.39,2.56A3.82,3.82,0,0,1,502.84,118.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.66,
    y: 67.71,
    width: 92.36,
    height: 13.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.98,
    y: 74.41,
    width: 50.29,
    height: 6.7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.71,345.79c0,.06-1,.16-2.8.68a23.92,23.92,0,0,0-7,3.42,19.21,19.21,0,0,0-3.92,3.64,13.72,13.72,0,0,0-1.61,2.48,17.11,17.11,0,0,0-1,3c-1,4.23-.73,9.08-.52,14.14s-.12,10.07-2.12,14.12a15.76,15.76,0,0,1-3.77,5,18.32,18.32,0,0,1-9,4.23,15.76,15.76,0,0,1-3.4.14,12.46,12.46,0,0,1-2.13-.33,3.77,3.77,0,0,1-.71-.22c0-.08,1,.24,2.85.32a16.64,16.64,0,0,0,3.33-.25,17.89,17.89,0,0,0,4.21-1.35,17.56,17.56,0,0,0,4.47-2.92,15.4,15.4,0,0,0,3.6-4.9c1.9-3.93,2.22-8.84,2-13.86s-.52-10,.59-14.3a18.25,18.25,0,0,1,1.07-3.07,14.68,14.68,0,0,1,1.7-2.57,19.33,19.33,0,0,1,4.06-3.67,23,23,0,0,1,7.16-3.3,15.23,15.23,0,0,1,2.11-.4A2.51,2.51,0,0,1,567.71,345.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.13,
    y: 391.96,
    width: 7.58,
    height: 9.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.71,
    y: 322.49,
    width: 42.52,
    height: 46.59,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.97,
    cy: 345.97,
    r: 14,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.97,
    cy: 345.97,
    r: 7,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.46,
    cy: 329.72,
    r: 1.3,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,329.72a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,605,329.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.3,364.12a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,605.3,364.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.76,364.66a1.3,1.3,0,1,1-1.3-1.3A1.3,1.3,0,0,1,574.76,364.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 322.49,
    width: 3.43,
    height: 46.59,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.63,202.6l-18.54-4.55.13,0a30.79,30.79,0,0,1-16,4.79,33.6,33.6,0,0,1-9.92-1.44A31.13,31.13,0,0,1,31,175.59a30.66,30.66,0,0,1,8-24.75,32.2,32.2,0,0,1,5.37-4.68c1-.62,2-1.26,3-1.8l1.57-.76.79-.38.82-.3a31.38,31.38,0,0,1,13.32-2A30.9,30.9,0,0,1,91,161.66a32.14,32.14,0,0,1,1.71,10,30.71,30.71,0,0,1-4.44,16.06v-.17c5.16,9.31,7.76,14,8.34,15-.6-1-3.29-5.67-8.63-14.87l0-.09,0-.08a30.52,30.52,0,0,0,4.28-15.88,31.65,31.65,0,0,0-1.73-9.85,30.22,30.22,0,0,0-5.42-9.55,30.58,30.58,0,0,0-34.42-8.79l-.8.29-.77.38-1.55.74c-1,.53-2,1.17-3,1.77a31.38,31.38,0,0,0-5.26,4.59A30.53,30.53,0,0,0,52.46,200.9a33.1,33.1,0,0,0,9.75,1.46A30.54,30.54,0,0,0,78,197.73l.06,0,.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.18,158.07l1,15.48a2.5,2.5,0,0,0,2.36,2.35h0a2.52,2.52,0,0,0,2.65-2.23l1.71-15.56a2,2,0,0,0-2-2.19l-3.78.05A2,2,0,0,0,59.18,158.07Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.62,184.61a3.78,3.78,0,1,1-2.39-4.77A3.76,3.76,0,0,1,66.62,184.61Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.79,156.92c-.06,0-.93-1.09-2.4-2.85s-3.57-4.15-5.9-6.77-4.4-5.06-5.8-6.89c-.7-.92-1.25-1.67-1.6-2.21a3.57,3.57,0,0,1-.51-.87c.06,0,.93,1.08,2.4,2.85s3.57,4.15,5.9,6.77,4.4,5.05,5.8,6.89c.7.92,1.25,1.67,1.6,2.21A3.37,3.37,0,0,1,313.79,156.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.94,146.47c-.13.05-4.32-12-9.36-27s-9-27.09-8.86-27.14,4.32,12,9.36,27S333.08,146.43,332.94,146.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.53,149.61c-.14-.05,1.91-6.72,4.56-14.9S359,119.92,359.15,120s-1.9,6.72-4.56,14.91S349.67,149.65,349.53,149.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,148.77c.08.12-2.47,2.08-5.49,4.63s-5.4,4.72-5.5,4.62a8.09,8.09,0,0,1,1.4-1.59c.92-.92,2.24-2.15,3.76-3.43s3-2.37,4-3.12A7.46,7.46,0,0,1,377.63,148.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,108.59c.13,0,0,.79-.28,1.67s-.64,1.54-.78,1.49,0-.78.28-1.66S362.37,108.55,362.51,108.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.72,132c-.11.09-.5-.26-.87-.77s-.56-1-.44-1.07.5.26.87.77S292.84,132,292.72,132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,164H274.1a3.93,3.93,0,0,0-3.93,3.93v88.86a3.93,3.93,0,0,0,3.93,3.93h48.28s3.07,9.49-6.45,14.41h45.15s-10.75-3.69-8-14.41H399.9a3.93,3.93,0,0,0,3.93-3.93V167.93A3.93,3.93,0,0,0,399.9,164Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.68,251.37a2.42,2.42,0,0,1-3.41,3.41.7.7,0,0,1-.21-.21,2.42,2.42,0,0,1,3.41-3.41A1,1,0,0,1,338.68,251.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,165.63H398.81a2.85,2.85,0,0,1,2.85,2.85v76a0,0,0,0,1,0,0H272.34a0,0,0,0,1,0,0v-76A2.85,2.85,0,0,1,275.19,165.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32,165.63h123.9a2.45,2.45,0,0,1,2.45,2.45v4.1a0,0,0,0,1,0,0H272.34a0,0,0,0,1,0,0v-3.57A3,3,0,0,1,275.32,165.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.36,169.05a.91.91,0,1,1-.9-.91A.9.9,0,0,1,277.36,169.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.07,169.05a.91.91,0,1,1-.91-.91A.9.9,0,0,1,280.07,169.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65,169.05a.91.91,0,1,1-.91-.91A.9.9,0,0,1,282.65,169.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.41,260.73s-17.9.07-40,.07-40,0-40-.07,17.89-.08,40-.08S377.41,260.69,377.41,260.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76,201.15c0,4-2.92,7.45-9.35,7.45a15.53,15.53,0,0,1-8.57-2.41l2.06-4a10.83,10.83,0,0,0,6.39,2c2.6,0,4.2-1.09,4.2-2.92s-1.15-2.92-5.23-2.92h-5.75l1.16-12.65h13.71v4.17H314l-.35,4.27h1.83C322.12,194.18,324.76,197.17,324.76,201.15Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.87,197c0-7.41,4.11-11.62,9.63-11.62s9.63,4.21,9.63,11.62-4.07,11.63-9.63,11.63S326.87,204.39,326.87,197Zm14,0c0-5.1-1.8-7.22-4.4-7.22s-4.36,2.12-4.36,7.22,1.79,7.23,4.36,7.23S340.9,202.08,340.9,197Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.67,197c0-7.41,4.11-11.62,9.63-11.62s9.63,4.21,9.63,11.62-4.08,11.63-9.63,11.63S348.67,204.39,348.67,197Zm14,0c0-5.1-1.8-7.22-4.4-7.22s-4.37,2.12-4.37,7.22,1.8,7.23,4.37,7.23S362.7,202.08,362.7,197Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,214.06h.95v6.64h-.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.16,214.06v6.64h-.77l-4-4.95v4.95h-.95v-6.64h.78l4,5v-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.47,214.89h-2.28v-.83h5.5v.83h-2.28v5.81h-.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.54,219.88v.82h-4.82v-6.64h4.69v.83h-3.74v2H312v.8h-3.33v2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.52,220.7l-1.44-2-.41,0H315v2h-.94v-6.64h2.59c1.72,0,2.77.87,2.77,2.32a2.09,2.09,0,0,1-1.46,2.09l1.57,2.23Zm0-4.32c0-.95-.64-1.49-1.85-1.49H315v3h1.62C317.85,217.88,318.49,217.33,318.49,216.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.69,214.06v6.64h-.78l-4-4.95v4.95H321v-6.64h.78l4,5v-5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91,219h-3.53l-.73,1.66h-1l3-6.64h.94l3,6.64h-1Zm-.34-.76L331.14,215l-1.43,3.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62,214.06h.95v5.82h3.59v.82h-4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.19,220l.36-.74a3.42,3.42,0,0,0,2.19.76c1.15,0,1.64-.44,1.64-1,0-1.62-4-.6-4-3.07,0-1,.79-1.89,2.54-1.89a3.94,3.94,0,0,1,2.14.58l-.32.76a3.42,3.42,0,0,0-1.82-.54c-1.13,0-1.61.48-1.61,1.06,0,1.62,4,.6,4,3,0,1-.82,1.89-2.57,1.89A4,4,0,0,1,343.19,220Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.52,219.88v.82h-4.83v-6.64h4.69v.83h-3.74v2H354v.8h-3.33v2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.49,220.7l-1.43-2-.42,0H357v2h-.95v-6.64h2.59c1.73,0,2.77.87,2.77,2.32a2.09,2.09,0,0,1-1.46,2.09l1.57,2.23Zm0-4.32c0-.95-.63-1.49-1.85-1.49H357v3h1.61C359.83,217.88,360.46,217.33,360.46,216.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.71,214.06l-2.91,6.64h-.94l-2.92-6.64h1l2.4,5.46,2.41-5.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.38,219.88v.82h-4.82v-6.64h4.68v.83H370.5v2h3.34v.8H370.5v2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.35,220.7l-1.43-2-.42,0h-1.64v2h-.95v-6.64h2.59c1.73,0,2.77.87,2.77,2.32a2.09,2.09,0,0,1-1.46,2.09l1.58,2.23Zm0-4.32c0-.95-.63-1.49-1.85-1.49h-1.61v3h1.61C379.69,217.88,380.32,217.33,380.32,216.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.12,231.33v1.32h-5.47v-7.07H326v1.31h-3.72v1.54h3.29v1.27h-3.29v1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,232.65l-1.36-2h-1.51v2h-1.64v-7.07h3.06c1.89,0,3.08,1,3.08,2.56a2.3,2.3,0,0,1-1.46,2.23l1.59,2.28Zm-1.54-5.74h-1.33v2.46h1.33c1,0,1.51-.46,1.51-1.23S331.39,226.91,330.39,226.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.35,232.65l-1.36-2h-1.51v2h-1.63v-7.07h3.06c1.89,0,3.07,1,3.07,2.56a2.3,2.3,0,0,1-1.46,2.23l1.59,2.28Zm-1.53-5.74h-1.34v2.46h1.34c1,0,1.5-.46,1.5-1.23S338.82,226.91,337.82,226.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,229.11a3.88,3.88,0,1,1,3.87,3.66A3.66,3.66,0,0,1,341.82,229.11Zm6.08,0a2.21,2.21,0,1,0-2.21,2.26A2.16,2.16,0,0,0,347.9,229.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.3,232.65l-1.37-2h-1.5v2h-1.64v-7.07h3.06c1.89,0,3.07,1,3.07,2.56a2.29,2.29,0,0,1-1.45,2.23l1.58,2.28Zm-1.54-5.74h-1.33v2.46h1.33c1,0,1.51-.46,1.51-1.23S354.76,226.91,353.76,226.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,206.3a2.35,2.35,0,0,1-2.06-1.2,2.39,2.39,0,0,1,0-2.4l6.95-11.91a2.39,2.39,0,0,1,2.08-1.19h0a2.38,2.38,0,0,1,2.06,1.21l6.84,12a2.35,2.35,0,0,1,0,2.39,2.38,2.38,0,0,1-2.08,1.19l-13.79-.07Zm7-16h0a1.64,1.64,0,0,0-1.46.83l-6.95,11.91a1.68,1.68,0,0,0,1.44,2.53h0l13.79.06a1.68,1.68,0,0,0,1.47-2.51l-6.84-12A1.66,1.66,0,0,0,292.67,190.32Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.63,202.47a.87.87,0,0,1,.92-.87.86.86,0,0,1,.9.88.88.88,0,0,1-.9.89A.89.89,0,0,1,291.63,202.47Zm.08-7.18h1.69l-.29,5.35H292Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.72,206.3a2.35,2.35,0,0,1-2.06-1.2,2.39,2.39,0,0,1,0-2.4l6.95-11.91a2.39,2.39,0,0,1,2.08-1.19h0a2.38,2.38,0,0,1,2.06,1.21l6.84,12a2.35,2.35,0,0,1,0,2.39,2.38,2.38,0,0,1-2.08,1.19l-13.79-.07Zm7-16h0a1.64,1.64,0,0,0-1.46.83l-6.95,11.91a1.68,1.68,0,0,0,1.44,2.53h0l13.8.06a1.68,1.68,0,0,0,1.46-2.51l-6.84-12A1.66,1.66,0,0,0,380.7,190.32Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.66,202.47a.87.87,0,0,1,.92-.87.86.86,0,0,1,.9.88.88.88,0,0,1-.9.89A.89.89,0,0,1,379.66,202.47Zm.08-7.18h1.69l-.29,5.35H380Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-139"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "639.4 367.22 645.3 406 679.59 406 687.55 367.78 639.4 367.22",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.75,392.08c0,.11-8.78.2-19.62.2s-19.62-.09-19.62-.2,8.78-.2,19.62-.2S682.75,392,682.75,392.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.89,390.17c0,.11-8.85.2-19.76.2s-19.76-.09-19.76-.2,8.85-.2,19.76-.2S682.89,390.06,682.89,390.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.82,388c0,.12-8.85.21-19.76.21s-19.76-.09-19.76-.21,8.85-.2,19.76-.2S682.82,387.9,682.82,388Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.24,403.79a31.07,31.07,0,0,1-1-4.88,30.41,30.41,0,0,1-.66-5,30.73,30.73,0,0,1,1.05,4.88A31.66,31.66,0,0,1,649.24,403.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.57,403.38a37.92,37.92,0,0,1-.43-4.76,39.88,39.88,0,0,1-.22-4.78,22.55,22.55,0,0,1,.63,4.75A22.8,22.8,0,0,1,651.57,403.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.82,403.38a38.95,38.95,0,0,1-1.15-9.85,144.66,144.66,0,0,1,1.15,9.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.81,403.58a24.1,24.1,0,0,1-.48-5,24.42,24.42,0,0,1,.15-5,41.19,41.19,0,0,1,.25,5A43.85,43.85,0,0,1,658.81,403.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.09,403.38a28.39,28.39,0,0,1-.36-4.71,28,28,0,0,1,0-4.73,28.45,28.45,0,0,1,.36,4.72A27.81,27.81,0,0,1,664.09,403.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668,403.58a28.82,28.82,0,0,1-.16-4.87,29.64,29.64,0,0,1,.24-4.87,30.13,30.13,0,0,1,.16,4.87A29.53,29.53,0,0,1,668,403.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.57,403.07a64.61,64.61,0,0,1,1-10.15,64.92,64.92,0,0,1-1,10.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.23,402.56a17.51,17.51,0,0,1,.58-4.33,17.14,17.14,0,0,1,1.27-4.18,37.49,37.49,0,0,1-.88,4.26A36.38,36.38,0,0,1,676.23,402.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.93,290.68a.67.67,0,0,1,0,.19c0,.15-.1.33-.16.55-.16.51-.38,1.21-.65,2.09s-.65,2-1,3.32-.83,2.77-1.24,4.42-.9,3.45-1.33,5.41-.88,4-1.33,6.24c-.82,4.42-1.57,9.31-2.1,14.48s-.73,10.11-.8,14.6c0,2.25,0,4.39.06,6.39s.14,3.86.25,5.56.23,3.23.33,4.58.23,2.5.33,3.45.18,1.65.23,2.18c0,.23,0,.42,0,.57s0,.19,0,.19a1,1,0,0,1,0-.19c0-.15-.05-.33-.09-.56-.07-.53-.17-1.25-.3-2.17s-.28-2.1-.4-3.45-.31-2.88-.4-4.58-.24-3.57-.29-5.57-.09-4.14-.1-6.4c.05-4.51.27-9.46.77-14.64s1.3-10.08,2.14-14.51c.46-2.2.87-4.31,1.36-6.25s.93-3.76,1.39-5.4.9-3.12,1.29-4.41.76-2.41,1.08-3.3.54-1.57.72-2.08l.2-.53A.82.82,0,0,1,672.93,290.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.74,314.7a12.75,12.75,0,0,1,5.33-6.73,3,3,0,0,1,2.82-.52c1.2.58,1.29,2.26.94,3.54a9.41,9.41,0,0,1-3.88,5.29,8,8,0,0,1-5.83,1.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.66,330.92c.88-3.35,3.55-8.11,6.33-10.18a4,4,0,0,1,1.44-.77,1.67,1.67,0,0,1,1.54.33,2.39,2.39,0,0,1,.34,2.23,13.5,13.5,0,0,1-10,10.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.08,345.19a19.68,19.68,0,0,1,6.39-8,3,3,0,0,1,2.23-.79c1.21.22,1.76,1.7,1.65,2.92-.22,2.53-2.15,4.55-4.14,6.12a25.65,25.65,0,0,1-5.91,3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.41,355.45a18.87,18.87,0,0,1,5.43-6.18,3.87,3.87,0,0,1,1.63-.73,1.67,1.67,0,0,1,1.6.61c.54.8,0,1.88-.56,2.65a15.5,15.5,0,0,1-7.75,5.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.14,351.29a60.58,60.58,0,0,0-7.77-7.92c-.44-.37-1-.76-1.55-.58a1.13,1.13,0,0,0-.71,1,3,3,0,0,0,.29,1.3,15,15,0,0,0,10,8.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.38,337.93l-6.1-7.44a7.37,7.37,0,0,0-2-1.88,2.22,2.22,0,0,0-3.44,2.43,6.53,6.53,0,0,0,1.19,2.44,18.23,18.23,0,0,0,4.45,4.73c1.79,1.23,3.42,2,5.57,1.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.23,322.9a21.17,21.17,0,0,0-6.14-9.22,3.54,3.54,0,0,0-1.6-.94,2.71,2.71,0,0,0-2.8,2,5.06,5.06,0,0,0,.56,4,10.61,10.61,0,0,0,2.87,3,24.67,24.67,0,0,0,6.79,3.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.67,309.49c-.59-4.31-2.83-7.9-5.44-11.39-.54-.74-1.31-1.52-2.22-1.38a1.75,1.75,0,0,0-1.27,1.09,4,4,0,0,0-.24,1.73,13.31,13.31,0,0,0,8.64,11.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.38,302.64a35.42,35.42,0,0,1-.22-6.67,11.91,11.91,0,0,1,2.21-6.21,5.08,5.08,0,0,1,2.22-1.76,2.79,2.79,0,0,1,2.72.36,3,3,0,0,1,.93,2.39,7.67,7.67,0,0,1-.69,2.56c-1.63,3.91-4.34,8.24-7.17,9.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.79,307.78a2.7,2.7,0,0,1,0,.55c0,.4,0,.92,0,1.57s0,1.51,0,2.47,0,2.07.12,3.28c.1,2.42.34,5.31.71,8.5s.94,6.67,1.69,10.3,1.67,7,2.59,10.11,1.89,5.8,2.76,8.07c.42,1.14.85,2.15,1.21,3.05s.69,1.66,1,2.28.46,1.07.61,1.44a2.13,2.13,0,0,1,.19.51,3,3,0,0,1-.26-.48l-.68-1.41c-.3-.61-.65-1.36-1-2.26s-.84-1.89-1.27-3c-.91-2.25-1.89-5-2.86-8.06s-1.85-6.5-2.63-10.14-1.29-7.14-1.66-10.34-.56-6.1-.63-8.53c-.06-1.22,0-2.32-.06-3.28s0-1.8,0-2.48.05-1.17.06-1.57A3.43,3.43,0,0,1,642.79,307.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.75,325.47a9.06,9.06,0,0,1,2.18-5.73,2.15,2.15,0,0,1,1.81-1c.93.13,1.36,1.26,1.39,2.21a6.67,6.67,0,0,1-1.5,4.43,5.63,5.63,0,0,1-3.65,2.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.82,337c-.12-2.47.68-6.29,2.12-8.29a3.09,3.09,0,0,1,.81-.84,1.21,1.21,0,0,1,1.12-.1,1.69,1.69,0,0,1,.71,1.44,9.62,9.62,0,0,1-4.64,9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.5,346.8a14,14,0,0,1,2.62-6.84,2.14,2.14,0,0,1,1.35-1c.87-.11,1.56.78,1.75,1.64.4,1.76-.48,3.56-1.5,5.05a18.55,18.55,0,0,1-3.37,3.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.93,353.72a13.31,13.31,0,0,1,2.37-5.38,2.67,2.67,0,0,1,1-.85,1.19,1.19,0,0,1,1.22.07c.54.43.42,1.28.19,1.93a11.11,11.11,0,0,1-4,5.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.85,350.94a43.37,43.37,0,0,0-7-3.72,1.24,1.24,0,0,0-1.18-.06.81.81,0,0,0-.26.86,2,2,0,0,0,.48.82,10.74,10.74,0,0,0,8.62,3.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.14,341.79,641.39,338a5.22,5.22,0,0,0-1.76-.85,1.58,1.58,0,0,0-1.82,2.39,4.62,4.62,0,0,0,1.34,1.41,13,13,0,0,0,4.05,2.26,5.31,5.31,0,0,0,4.16,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.49,331.37a15.3,15.3,0,0,0-6.17-4.95,2.57,2.57,0,0,0-1.29-.29,1.92,1.92,0,0,0-1.49,1.94,3.66,3.66,0,0,0,1.25,2.63,7.61,7.61,0,0,0,2.61,1.45,17.82,17.82,0,0,0,5.41,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.26,321.72c-1.33-2.81-3.63-4.77-6.16-6.58a1.87,1.87,0,0,0-1.8-.47,1.27,1.27,0,0,0-.64,1,2.9,2.9,0,0,0,.21,1.23,9.51,9.51,0,0,0,8.45,6.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,316.69a25.49,25.49,0,0,1-1.59-4.49,8.57,8.57,0,0,1,.17-4.71,3.75,3.75,0,0,1,1.13-1.68,2,2,0,0,1,1.93-.34,2.13,2.13,0,0,1,1.15,1.43,5.22,5.22,0,0,1,.08,1.89c-.26,3-1.18,6.55-2.87,7.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.14,307.41a2.34,2.34,0,0,1,.05.54c0,.4,0,.92.06,1.57s0,1.51,0,2.48,0,2.07-.06,3.28c-.07,2.44-.28,5.33-.62,8.53s-.91,6.7-1.67,10.34-1.69,7.06-2.63,10.14-1.94,5.81-2.85,8.07c-.44,1.14-.89,2.14-1.27,3s-.73,1.64-1,2.26-.51,1.05-.69,1.41a3.71,3.71,0,0,1-.26.48,2.55,2.55,0,0,1,.19-.52c.16-.36.36-.84.61-1.44s.61-1.38,1-2.28.8-1.9,1.21-3.05c.88-2.26,1.82-5,2.77-8.06s1.82-6.49,2.59-10.12,1.29-7.11,1.69-10.3.6-6.07.71-8.5c.08-1.21.08-2.31.12-3.27s0-1.8,0-2.48,0-1.17,0-1.56A3.93,3.93,0,0,1,686.14,307.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.19,325.09a9.08,9.08,0,0,0-2.18-5.73,2.19,2.19,0,0,0-1.81-1c-.94.14-1.37,1.26-1.4,2.21a6.75,6.75,0,0,0,1.5,4.44A5.67,5.67,0,0,0,685,327.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.12,336.58c.11-2.47-.68-6.28-2.12-8.29a2.82,2.82,0,0,0-.82-.83,1.21,1.21,0,0,0-1.12-.11,1.69,1.69,0,0,0-.71,1.44,9.63,9.63,0,0,0,4.64,9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.43,346.43a14,14,0,0,0-2.62-6.85,2.22,2.22,0,0,0-1.34-1c-.87-.11-1.57.78-1.76,1.64-.39,1.77.49,3.56,1.5,5.06a18.35,18.35,0,0,0,3.37,3.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678,353.34a13.65,13.65,0,0,0-2.37-5.38,3,3,0,0,0-.95-.85,1.21,1.21,0,0,0-1.22.07c-.55.43-.43,1.28-.2,1.93a11.07,11.07,0,0,0,4.06,5.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.09,350.56a42.9,42.9,0,0,1,7-3.71,1.25,1.25,0,0,1,1.18-.07.83.83,0,0,1,.26.87,2.27,2.27,0,0,1-.48.82,10.78,10.78,0,0,1-8.62,3.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.79,341.42l5.76-3.76a5.36,5.36,0,0,1,1.75-.85,1.8,1.8,0,0,1,1.78.54,1.74,1.74,0,0,1,0,1.85,4.5,4.5,0,0,1-1.34,1.41,12.9,12.9,0,0,1-4,2.26,5.31,5.31,0,0,1-4.16,0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.45,331a15.17,15.17,0,0,1,6.17-5,2.54,2.54,0,0,1,1.29-.29,1.92,1.92,0,0,1,1.48,1.94,3.57,3.57,0,0,1-1.25,2.63,7.52,7.52,0,0,1-2.61,1.45,17.48,17.48,0,0,1-5.41,1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.68,321.35c1.33-2.81,3.63-4.77,6.15-6.59a1.87,1.87,0,0,1,1.81-.46,1.25,1.25,0,0,1,.63,1,2.86,2.86,0,0,1-.21,1.22,9.51,9.51,0,0,1-8.45,6.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686,316.32a25.84,25.84,0,0,0,1.58-4.5,8.44,8.44,0,0,0-.17-4.7,3.59,3.59,0,0,0-1.13-1.68,2,2,0,0,0-1.92-.34,2.09,2.09,0,0,0-1.15,1.43,5.44,5.44,0,0,0-.09,1.89c.27,3,1.18,6.54,2.88,7.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.46,359.54v7.25a2.86,2.86,0,0,0,2.86,2.86H688a2.86,2.86,0,0,0,2.86-2.86v-7.25Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "639.77 369.65 640.18 371.96 686 375.23 687.16 369.65 639.77 369.65"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.25,406.42c0,.14-152.79.26-341.23.26s-341.27-.12-341.27-.26,152.76-.26,341.27-.26S716.25,406.27,716.25,406.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.06,196h1.16a22.13,22.13,0,0,1,22.25,20.07c.85,10.53,1.65,22.16,1.57,27.81-.18,11.69-12.19,13.48-12.19,13.48l.45,10.38a14.3,14.3,0,0,1-13.46,14.76h0a14.29,14.29,0,0,1-15.11-13.59l-2.49-49.38C125.19,207.41,131.57,196.69,144.06,196Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,257.35a29.65,29.65,0,0,1-15.71-4.51s3.68,8.42,15.66,7.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,224.6a1.7,1.7,0,0,1-1.66,1.68,1.62,1.62,0,0,1-1.76-1.51,1.69,1.69,0,0,1,1.65-1.68A1.63,1.63,0,0,1,164.93,224.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88,221.8c-.21.21-1.51-.73-3.36-.72s-3.19.89-3.39.67.12-.49.71-.9a4.8,4.8,0,0,1,2.72-.82,4.64,4.64,0,0,1,2.67.85C164.79,221.3,165,221.7,164.88,221.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,224.6a1.69,1.69,0,0,1-1.65,1.68,1.63,1.63,0,0,1-1.77-1.51,1.7,1.7,0,0,1,1.66-1.68A1.62,1.62,0,0,1,148,224.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.66,222.09c-.22.22-1.51-.72-3.36-.72s-3.2.9-3.39.68.11-.49.71-.91a4.88,4.88,0,0,1,2.72-.81,4.67,4.67,0,0,1,2.67.85C147.57,221.6,147.76,222,147.66,222.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.41,235.43a12.8,12.8,0,0,1,3-.52c.47,0,.92-.14,1-.45a2.34,2.34,0,0,0-.31-1.36c-.45-1.11-.91-2.28-1.39-3.5-1.92-5-3.32-9.06-3.11-9.14s1.93,3.9,3.86,8.88l1.32,3.51a2.6,2.6,0,0,1,.25,1.8,1.15,1.15,0,0,1-.78.67,3.11,3.11,0,0,1-.8.11A12.85,12.85,0,0,1,153.41,235.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,217.12c0-.52,1.79-1,3.71-2s3.34-2.21,3.76-1.91c.2.15.08.69-.4,1.39a7.5,7.5,0,0,1-5.69,3C138.5,217.57,138,217.36,138,217.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,215.53c.46-.24,1.46.65,2.85,1.27s2.7.87,2.81,1.38c0,.24-.31.54-1,.67a4.38,4.38,0,0,1-2.59-.4,4.31,4.31,0,0,1-2-1.74C159.58,216.11,159.58,215.66,159.79,215.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,228.2c-.21-.09-8.25-2.39-8,5.6s8.43,6.1,8.44,5.87S128,228.2,128,228.2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,236.72s-.14.1-.38.22a1.47,1.47,0,0,1-1.06.05c-.88-.29-1.65-1.61-1.74-3.05a4.63,4.63,0,0,1,.34-2,1.65,1.65,0,0,1,1-1.1.73.73,0,0,1,.85.36c.12.22.07.38.12.39s.17-.14.09-.47a.92.92,0,0,0-.34-.49,1.09,1.09,0,0,0-.79-.18,2,2,0,0,0-1.46,1.28,4.6,4.6,0,0,0-.43,2.25c.11,1.6,1,3.09,2.19,3.39a1.61,1.61,0,0,0,1.31-.25C126.59,236.91,126.63,236.73,126.6,236.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,204.45l34.22.73a15.43,15.43,0,0,0-5-5.66,27.13,27.13,0,0,0-15.5-5.43c-5.58-.1-16.94,6.52-21,10.27-3.24,3-3.22,5.59-3.22,5.59-.51,4.32,2,9.23,3,13.48.51,2.18,1.49,8.8,1.49,8.8h0c1.89,0,2.59-1.47,2.3-3.28l-.35-7.12a10.62,10.62,0,0,0,3.38-12.56C132.2,208.62,131.16,205.66,133.42,204.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,229.72a.21.21,0,0,1-.24-.18.2.2,0,1,1,.4-.07A.21.21,0,0,1,140.6,229.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.13,229a.24.24,0,0,1-.25-.21.22.22,0,0,1,.15-.28.24.24,0,0,1,.25.21A.23.23,0,0,1,144.13,229Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.5,228.89c-.11,0-.22-.11-.24-.29s.05-.33.16-.35.22.12.24.3S146.61,228.88,146.5,228.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.33,231.88c-.11,0-.2-.06-.2-.13s.09-.13.2-.13.2.06.2.13S142.44,231.88,142.33,231.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56,231.15a.21.21,0,0,1-.22-.21.22.22,0,0,1,.18-.24.22.22,0,0,1,.23.21A.21.21,0,0,1,145.56,231.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.39,229.23a.23.23,0,0,1-.25-.18.22.22,0,0,1,.16-.26.21.21,0,0,1,.24.18A.21.21,0,0,1,162.39,229.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,229a.24.24,0,0,1-.23-.23.23.23,0,0,1,.18-.27c.11,0,.21.1.23.23A.23.23,0,0,1,164.79,229Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,229.28a.19.19,0,0,1-.24-.13.19.19,0,0,1,.17-.21.19.19,0,0,1,.23.14A.18.18,0,0,1,160.27,229.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,231.63a.23.23,0,0,1-.28-.13.21.21,0,0,1,.09-.29.21.21,0,0,1,.28.13A.2.2,0,0,1,162,231.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09,231.23a.19.19,0,0,1-.15-.21.2.2,0,0,1,.25-.11.19.19,0,0,1,.15.21A.2.2,0,0,1,164.09,231.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,204.82a9.6,9.6,0,0,1,1.92-8.57,10.17,10.17,0,0,1,8.19-3.68,33.49,33.49,0,0,0,4.78.33c3-.31,5.24-2.62,8-3.75a10.58,10.58,0,0,1,12.3,3.6c1,1.51,1.73,3.38,3.32,4.34,1.38.82,3.12.75,4.67,1.21a7.4,7.4,0,0,1,5.11,7.34,8.76,8.76,0,0,1-5.46,7.34,11.25,11.25,0,0,1-9.46-.65c-2.58-1.4-4.89-3.79-7.84-3.7s-5.74,2.89-8.74,2.31c-1.57-.31-2.78-1.49-3.94-2.57s-2.47-2.2-4.08-2.29-2.43,2-1.86,3.51l-6.9-4.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,201s0,0-.05.12a3.33,3.33,0,0,1-.2.32,5.76,5.76,0,0,1-1,1.08,6,6,0,0,1-2,1.15,5.88,5.88,0,0,1-3.1.18,6.17,6.17,0,0,1-3.28-1.81,41.24,41.24,0,0,1-2.36-3.51,4.65,4.65,0,0,0-1.65-1.46,5,5,0,0,0-2.27-.49,5.32,5.32,0,0,0-2.33.61,4.38,4.38,0,0,0-1.72,1.72,24.53,24.53,0,0,1-1.21,2.25,2.86,2.86,0,0,1-2.19,1.3,4.35,4.35,0,0,1-2.39-.67,8.75,8.75,0,0,1-1.81-1.47,7.61,7.61,0,0,0-3.4-2.35,4.38,4.38,0,0,0-3.43.78,5.79,5.79,0,0,0-1.89,2.28,9.68,9.68,0,0,0-.71,2.14c-.12.61-.18,1.09-.22,1.42a2.16,2.16,0,0,1-.08.5v-.13c0-.09,0-.21,0-.38a12.25,12.25,0,0,1,.17-1.43,9.09,9.09,0,0,1,.66-2.19,5.88,5.88,0,0,1,1.92-2.39,4.62,4.62,0,0,1,3.64-.86,7.76,7.76,0,0,1,3.54,2.4,8.71,8.71,0,0,0,1.77,1.41,4,4,0,0,0,2.2.62,2.49,2.49,0,0,0,1.94-1.16c.47-.67.76-1.46,1.19-2.22a4.7,4.7,0,0,1,1.85-1.85,5.44,5.44,0,0,1,2.48-.64,4.75,4.75,0,0,1,4.18,2.08,39.6,39.6,0,0,0,2.32,3.51,6,6,0,0,0,3.12,1.77,5.82,5.82,0,0,0,3-.13,6.08,6.08,0,0,0,2-1.07A7.64,7.64,0,0,0,167,201Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,201.07a1.6,1.6,0,0,1,.14.64,4.87,4.87,0,0,1-.17,1.79,6.24,6.24,0,0,1-1.28,2.35,7.5,7.5,0,0,1-2.71,1.92,11.35,11.35,0,0,1-6,.65,17.12,17.12,0,0,1-1.79-.34,2.59,2.59,0,0,1-.64-.21c0-.05.94.17,2.46.33a11.94,11.94,0,0,0,5.81-.73,7.42,7.42,0,0,0,2.61-1.81,6.38,6.38,0,0,0,1.29-2.23A6.84,6.84,0,0,0,173.17,201.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,238.27a14.28,14.28,0,0,0-2.57-1.34,2,2,0,0,0-1.8.35,2.17,2.17,0,0,0-.65,1.44,2.68,2.68,0,0,0,.39,1.9,3.59,3.59,0,0,0,1.83,1.13,2.73,2.73,0,0,0,1.77.18,1.78,1.78,0,0,0,1.1-1.38,5.15,5.15,0,0,0-.07-2.28",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,241.83a2.4,2.4,0,0,1-1.6-.39,3,3,0,0,1-1.28-1.33,2.35,2.35,0,0,1,.11-2.29,2,2,0,0,1,1-.8,2.29,2.29,0,0,1,1.15-.09,5.09,5.09,0,0,1,1.67.7c.84.53,1.4.72,1.39.79s-.66,0-1.56-.46a5.38,5.38,0,0,0-1.57-.55,1.53,1.53,0,0,0-1.6.69,1.89,1.89,0,0,0-.11,1.81,2.86,2.86,0,0,0,1,1.22C149,241.65,149.63,241.74,149.61,241.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,218.45c-.14,0-.19-.87-.19-1.92s0-1.9.18-1.92.34.85.34,1.92S136,218.46,135.84,218.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.69,218.92a11.12,11.12,0,0,1-.06-4.78,11.12,11.12,0,0,1,.06,4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.94,408.34A5.07,5.07,0,0,0,75.76,410l-1.49,1.91a5.06,5.06,0,0,0-.76,4.82h0A5,5,0,0,0,78.38,420l44.29-1-4.45-17.79-1.91-5.14h0",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,419.67c.14-.05-.25-1.33-.09-2.93s.77-2.78.64-2.85a5.34,5.34,0,0,0-.55,5.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.16,418.7a22.07,22.07,0,0,1,.58-2.44,21.61,21.61,0,0,1,1.29-2.15c-.06-.12-1.18.54-1.74,2A3.12,3.12,0,0,0,100.16,418.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.44,419.91c.14,0-.18-1.44,0-3.16s.77-3,.63-3.11A5.13,5.13,0,0,0,91,416.7,5,5,0,0,0,91.44,419.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,419.81a11.87,11.87,0,0,1-.28-3.1,12.75,12.75,0,0,1,1-3s-.34.2-.67.7a5.15,5.15,0,0,0-.78,2.21,5.26,5.26,0,0,0,.26,2.33C86.66,419.55,86.89,419.84,87,419.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,399.68v.48S117,399.5,116.31,399.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,399.76l-.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,399.79l-.28.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37,400.5,78.7,407.56a10.82,10.82,0,0,0-3.28,1.76c-1.8,1.62-3.29,4.27-2.39,6.76,1.18,3.27,3.16,3.49,3.16,3.49s-2.42-3-1.72-5.25S77.79,410,81,408.73l35.09-9,.24-.08v-3.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,399.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.42,420.24a16.38,16.38,0,0,0,.91-5.75,16.18,16.18,0,0,0-1.65-5.58,3.81,3.81,0,0,1,1,1.43,10.38,10.38,0,0,1,1.14,4.12,10.49,10.49,0,0,1-.59,4.22A4.1,4.1,0,0,1,82.42,420.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,406.24a5.75,5.75,0,0,1-3.69-1.56,5.83,5.83,0,0,1-2.25-3.31,20.92,20.92,0,0,0,2.58,2.91A21,21,0,0,0,116.07,406.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,196a4.75,4.75,0,0,1,2.18-3.4c.13.67.25,1.33.38,2a6,6,0,0,1,4.74-2.63l-1.45,2.57a7,7,0,0,1,3.15-.42,7.54,7.54,0,0,1-2.53,2.59,4.77,4.77,0,0,0-2.1,2.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.49,264.28l-44.42,36.59c-.76-.64-14.27-27.24-14.27-27.24l38.81-23.09-33.35-29.87,8.61-6.53,42.22,23.56a16.17,16.17,0,0,1,8.26,13.16h0A16.17,16.17,0,0,1,222.49,264.28Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52,222.47l6.86-7.86h0l-8.93-8.27-2.34-5.89a3.64,3.64,0,0,0-3.13-4.32l-7.23-.46s-3.41-.19-3.09,2a1,1,0,0,0,.7.81l-.7,1.23c-.07,2,2.46,2.18,2.46,2.18l6,.56,1.2,3.16s-7.23-3.3-8.43-2,12.19,8.08,12.19,8.08l.54,8.69,1.4.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.11,200.62a5.13,5.13,0,0,0-1.3-1.38,4.77,4.77,0,0,0-1.9-.7,14.05,14.05,0,0,0-2.56-.1,42.52,42.52,0,0,1-6.73-.1,44.52,44.52,0,0,1,6.72-.42,12.11,12.11,0,0,1,2.66.15,4.73,4.73,0,0,1,2,.87C167.06,199.75,167.17,200.63,167.11,200.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.16,209.16c-.07,0-.28-.31-.74-.74a8.83,8.83,0,0,0-2-1.41,25.23,25.23,0,0,1-3.22-1.64,8.71,8.71,0,0,1,3.46,1.18,6.22,6.22,0,0,1,2.07,1.62C169.12,208.71,169.22,209.14,169.16,209.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,224.9a7,7,0,0,1-1.45-1.08c-.87-.72-2.07-1.75-3.44-3l.25,0a1.76,1.76,0,0,1-2-.88,3.58,3.58,0,0,1-.4-1.76c0-.56,0-1.07,0-1.58,0-.95.07-1.84.1-2.66a11.83,11.83,0,0,1,.22-2.45,10.51,10.51,0,0,1,.15,2.46c0,.82,0,1.71,0,2.66a6.85,6.85,0,0,0,.34,3.06,1.27,1.27,0,0,0,1.4.67l.14-.05.12.1c1.34,1.23,2.5,2.31,3.32,3.1A7.69,7.69,0,0,1,174,224.9Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.31,258a34.44,34.44,0,0,1-4-3.64c-2.13-2.08-4-3.54-4-3.64s2.17,1.17,4.32,3.27A23.93,23.93,0,0,1,210.31,258Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,202.1a5.59,5.59,0,0,1,2-1.5,2.49,2.49,0,0,1,2.41.28c.5.41.77,1,1.27,1.44a2.45,2.45,0,0,0,2.36.25,5.92,5.92,0,0,0,2-1.43c.18-.17.44-.36.65-.23a.47.47,0,0,1,.2.39,3,3,0,0,1-.45,2.06,1.32,1.32,0,0,0,1-.13,1.85,1.85,0,0,1-1.18,2.26,4.82,4.82,0,0,1-2.79,0,16.51,16.51,0,0,1-6.1-2.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1,284.88a37,37,0,0,1,15-31.45,34.13,34.13,0,0,1-14.62,31.88",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1,284.88a37,37,0,0,1,15-31.45,34.13,34.13,0,0,1-14.62,31.88"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,272.53l-25.1-22.34,30.44-30.64-11.87-8.67S74,238,66.75,245.59c-3.37,3.55-4.59,12.82-.47,17C76.94,273.47,98.42,293,98.42,293Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,205.21l-10.52-1.7,6.1-3.07,2.93-.1a4.13,4.13,0,0,0-3.85-3.29c-3.29-.21-3.82.45-3.82.45s-1.62-3.44-2.47-3.66a12.93,12.93,0,0,0-3.88-.62A7.79,7.79,0,0,0,130.3,195s-3.89-2.09-4.83-.78a27.72,27.72,0,0,0-2.15,5.33l-5.39,5.22-.91.55-15.84,12.36L112.49,229l13.7-14,2.23.67a3.78,3.78,0,0,0,3.25-1,15.86,15.86,0,0,0,2.29-2.39c.51-.66,1.53-2.4,1.73-2.59a6.79,6.79,0,0,1,1.76-1.23s11.14-.15,12-.67S151.32,205.65,148.6,205.21Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,199.84a10,10,0,0,1,2.85-1.65,7.12,7.12,0,0,1,3.17-.92,20.85,20.85,0,0,1-3,1.4A11.08,11.08,0,0,1,134.16,199.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.58,196.62c.13,0,.09.62-.11,1.3s-.46,1.2-.6,1.16-.09-.62.1-1.3S136.44,196.58,136.58,196.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,199a7.85,7.85,0,0,1,1.66-2.35c1-1.21,1.94-2.11,2.05-2a8.07,8.07,0,0,1-1.65,2.35C128,198.15,127.12,199.05,127,199Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.34,206.06s0,.09,0,.27a2.37,2.37,0,0,1-.16.77,1.41,1.41,0,0,1-.91.87,6.41,6.41,0,0,1-1.61.29c-1.18.1-2.61.18-4.18.2s-3.29,0-5.07.18a4.62,4.62,0,0,0-2.35.77,6.12,6.12,0,0,0-1.44,1.84,10.42,10.42,0,0,1-2.67,3.27,5.45,5.45,0,0,1-2.63,1.11,2.09,2.09,0,0,1-1,0s.37,0,1-.16a5.82,5.82,0,0,0,2.43-1.2,10.56,10.56,0,0,0,2.48-3.22,6.55,6.55,0,0,1,1.55-2,5,5,0,0,1,2.61-.87c1.82-.17,3.55-.15,5.12-.15s3,0,4.15-.09a7.45,7.45,0,0,0,1.55-.19A1.23,1.23,0,0,0,150,207C150.27,206.43,150.29,206,150.34,206.06Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,248.21a8.68,8.68,0,0,1-1.37,1.66c-.89,1-2.15,2.3-3.57,3.74s-2.72,2.73-3.68,3.64a9,9,0,0,1-1.63,1.4A9.21,9.21,0,0,1,83.89,257c.9-1,2.16-2.3,3.57-3.74s2.72-2.73,3.68-3.64A9,9,0,0,1,92.77,248.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.47,198.55a7.07,7.07,0,0,1-2.68-4.1l1.4,1a7.31,7.31,0,0,1,.33-6.08l2.41,4a2.86,2.86,0,0,1,1.52-2.13,13,13,0,0,0,1.1,6.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,196.06a11.36,11.36,0,0,1-2.51-3.59c.22-.11.47.05.67.19s.5.25.66.06.05-.4,0-.6a3.61,3.61,0,0,1,.25-3.09l2.77,5.16L129.34,196",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.22,424.92c-2.15-7-4.76-14-15.27-20.1l-10-5.06.83.34-44.33-22.64-.56,0-13.45-6.81-39.57,1.54-2.71,8.87-25.91,1.68-.6,20.3,0,8.49c-4.46-4.51-14.7.49-14.7,7.94l26,37.25c13,21.14,42.89,13.91,42.89,13.91l.38-.21a23.11,23.11,0,0,0,11-26.22L180,439.58l.25.59-.35-4.47.17.1,41.31,10.85c16.37,2.67,27.22,5.92,38.35-.95a17.87,17.87,0,0,0,5.24-4.9A18.16,18.16,0,0,0,267.22,424.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.57,440.12a3.6,3.6,0,0,0,1.05-.17,11.33,11.33,0,0,0,2.71-1.07,12.39,12.39,0,0,0,5.1-16.74,11.19,11.19,0,0,0-1.64-2.41A3.77,3.77,0,0,0,261,419a21,21,0,0,1,2.11,3.28,12.4,12.4,0,0,1-5,16.28A21.63,21.63,0,0,1,254.57,440.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92,460.41a91.65,91.65,0,0,0-2.16-9.45,94.92,94.92,0,0,0-2.66-9.33,96,96,0,0,0,2.17,9.46C135.61,456.27,136.79,460.45,136.92,460.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85,448.7a6.6,6.6,0,0,0,.51,2.06,20.22,20.22,0,0,0,5.74,8.44,6.46,6.46,0,0,0,1.73,1.24,39.37,39.37,0,0,1-4.73-5.37A39.75,39.75,0,0,1,133.85,448.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,466.52a2.25,2.25,0,0,0,.82.2,12.37,12.37,0,0,0,2.29.1,13.93,13.93,0,0,0,12-8.13,11.92,11.92,0,0,0,.76-2.17,2.46,2.46,0,0,0,.12-.83c-.08,0-.33,1.15-1.2,2.84a14.76,14.76,0,0,1-4.81,5.5,14.92,14.92,0,0,1-6.9,2.44C155.63,466.64,154.45,466.43,154.44,466.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,398.2a10.93,10.93,0,0,0,1.35-.69,32.91,32.91,0,0,1,3.72-1.67A29.93,29.93,0,0,1,162.63,398a32.77,32.77,0,0,1,3.4,2.27,9.51,9.51,0,0,0,1.21.9s-.08-.11-.27-.29-.45-.45-.82-.76a26.85,26.85,0,0,0-3.34-2.42,29,29,0,0,0-26.23-2.21,25.84,25.84,0,0,0-3.7,1.83c-.42.24-.73.46-.94.6S131.62,398.18,131.63,398.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,384.54a8.39,8.39,0,0,0-1.52,2,21.07,21.07,0,0,0-3.2,11.43,8.63,8.63,0,0,0,.27,2.47,33.82,33.82,0,0,1,1-8.28A33.23,33.23,0,0,1,181,384.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,442.9a6.64,6.64,0,0,1-.81-1.13c-.49-.75-1.16-1.86-2-3.24-1.62-2.75-3.74-6.64-5.94-11s-4.1-8.35-5.46-11.24c-.64-1.38-1.18-2.53-1.59-3.44a7.22,7.22,0,0,1-.53-1.29,7.57,7.57,0,0,1,.71,1.2c.42.79,1,1.94,1.74,3.37,1.47,2.95,3.43,6.85,5.6,11.16s4.25,8.25,5.79,11.05l1.84,3.31A7.58,7.58,0,0,1,132,442.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.23,440.9a2.73,2.73,0,0,1-.54-.11l-1.53-.39-5.59-1.55-18.41-5.24-18.4-5.25-5.59-1.56-1.52-.41a2.2,2.2,0,0,1-.53-.18,2.75,2.75,0,0,1,.55.08c.35.06.88.15,1.55.31,1.34.3,3.26.78,5.63,1.4,4.74,1.24,11.27,3.05,18.46,5.11s13.67,4,18.36,5.39l5.55,1.7,1.5.49A1.9,1.9,0,0,1,231.23,440.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,383.35a19.23,19.23,0,0,1,.32,2.91c.14,1.79.32,4.27.47,7s.24,5.24.23,7.05a18.41,18.41,0,0,1-.12,2.14,1.32,1.32,0,0,1-.23.76s0-.27,0-.78,0-1.22,0-2.12c-.11-2-.24-4.36-.38-7s-.28-5.23-.32-7A14.88,14.88,0,0,1,171.9,383.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,385.78s.12-.16.45-.26a2.06,2.06,0,0,1,1.41.12,2,2,0,0,1,1.16,1.78,2.36,2.36,0,0,1-.34,1.27,2,2,0,0,1-1.15.85,2.15,2.15,0,0,1-2.43-.88,2.19,2.19,0,0,1-.08-2.13,2.4,2.4,0,0,1,1-.95c.29-.15.47-.2.48-.17s-.12.14-.37.34a2.53,2.53,0,0,0-.83.94,1.88,1.88,0,0,0,.15,1.71,1.69,1.69,0,0,0,1.89.64,1.64,1.64,0,0,0,1.15-1.61,1.61,1.61,0,0,0-.84-1.46A2.62,2.62,0,0,0,166.16,385.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.52,405.46a8.77,8.77,0,0,1,.66,1.39c.39.91.92,2.23,1.53,3.89,1.23,3.31,2.73,7.95,4.22,13.13s2.72,9.89,3.58,13.31c.41,1.64.74,3,1,4.05a8.74,8.74,0,0,1,.3,1.51,8.21,8.21,0,0,1-.5-1.46c-.3-1-.68-2.38-1.15-4-1-3.48-2.29-8.12-3.73-13.26s-2.93-9.81-4.07-13.15c-.56-1.67-1-3-1.37-3.93A9.37,9.37,0,0,1,169.52,405.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46,441.2a2,2,0,0,0-.4-2.31,4.77,4.77,0,0,0-2.64-1.18l-3.91-.83a179.87,179.87,0,0,1-22.19-6.52,176.12,176.12,0,0,1-21.18-9.3c-1.32-.68-2.5-1.31-3.53-1.89s-1.91-1.06-2.62-1.49l-1.64-1a3.75,3.75,0,0,1-.55-.37,2.86,2.86,0,0,1,.6.28l1.69.89c.72.4,1.62.86,2.66,1.4s2.23,1.16,3.55,1.82a199.73,199.73,0,0,0,21.2,9.14,206.38,206.38,0,0,0,22.1,6.66l3.88.9a4.79,4.79,0,0,1,2.73,1.33,2.29,2.29,0,0,1,.55,1.83A1.1,1.1,0,0,1,231.46,441.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,327.35a1.9,1.9,0,0,0,.29.33l.9.91c.4.39.89.86,1.5,1.36s1.27,1.11,2.09,1.68,1.67,1.25,2.66,1.86,2.07,1.25,3.22,1.9a50.31,50.31,0,0,0,7.88,3.31,51.44,51.44,0,0,0,8.35,1.82c1.31.13,2.56.27,3.73.29s2.25,0,3.25,0,1.89-.11,2.67-.18a17.15,17.15,0,0,0,2-.25l1.26-.22a1.67,1.67,0,0,0,.43-.11,1.55,1.55,0,0,0-.45,0l-1.27.13c-.54.06-1.22.14-2,.17s-1.67.12-2.66.1-2.07,0-3.22-.07-2.39-.2-3.69-.34a52.49,52.49,0,0,1-8.26-1.83,51.94,51.94,0,0,1-7.82-3.25c-1.14-.63-2.24-1.2-3.21-1.84s-1.87-1.22-2.68-1.79-1.49-1.13-2.11-1.61-1.14-.92-1.55-1.29l-1-.84C128.81,327.43,128.69,327.33,128.68,327.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.36,337.32l-.71-9.46.76-26.3,23.84-18.73c-1.1-8.45-14.4-25.67-14.4-25.67l-20.32,8H167.1l-3,2.9-6.87-.94c-2.67,13.33-19.52,11.51-28.6.66l-9.91.87-3.64-3.28L110,266.8,96.09,253.43c-.3,14.11-5.54,24.18-15,31.45l20.06,21.6,5,5c1.84,26.39,3.57,51.73,8.64,77.09l5.24-1.15c26.75-.54,67.47-8.72,78.42-9.93l2.25-2.21-4-3.55Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.32,274.23a7.47,7.47,0,0,1,.37,1.49c.19,1,.45,2.36.68,4.1a79.29,79.29,0,0,1,.72,13.73,41,41,0,0,1-1,7.53,10.07,10.07,0,0,1-3,5.44,5.92,5.92,0,0,1-3.91,1.45,4.05,4.05,0,0,1-1.13-.21c-.25-.1-.37-.15-.36-.17a7.7,7.7,0,0,0,1.49.18,5.84,5.84,0,0,0,3.67-1.53,9.83,9.83,0,0,0,2.73-5.27,42.86,42.86,0,0,0,.92-7.44,92.77,92.77,0,0,0-.56-13.66c-.19-1.74-.39-3.15-.52-4.12A9.69,9.69,0,0,1,117.32,274.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,289.18a29.47,29.47,0,0,1-.32-3.1,52.32,52.32,0,0,0-3.46-14.5,25.74,25.74,0,0,1-1.12-2.91,2.94,2.94,0,0,1,.45.71c.27.47.61,1.17,1,2.05a42,42,0,0,1,2.41,7.16,40.92,40.92,0,0,1,1.08,7.46c0,1,.06,1.75,0,2.29A3,3,0,0,1,127.68,289.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.43,370.34a2.69,2.69,0,0,1-.49.28l-1.47.72c-.64.31-1.42.68-2.36,1.07s-2,.86-3.17,1.29c-2.37.93-5.24,1.88-8.48,2.79a99.92,99.92,0,0,1-10.69,2.26,98.35,98.35,0,0,1-10.88,1c-3.36.09-6.39,0-8.93-.16-1.27-.06-2.41-.2-3.41-.3s-1.86-.22-2.57-.33l-1.61-.26a2.19,2.19,0,0,1-.56-.12,2.26,2.26,0,0,1,.57,0l1.63.16c.7.08,1.56.17,2.57.24s2.14.19,3.41.22c2.52.14,5.54.17,8.88.06A97.56,97.56,0,0,0,168.34,376c3.22-.87,6.1-1.78,8.47-2.66,1.2-.41,2.25-.86,3.19-1.22s1.74-.7,2.39-1l1.5-.63A1.86,1.86,0,0,1,184.43,370.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124,269.49c2.77,6.81,5,14.86,5.17,22.21a8.73,8.73,0,0,1-.74,4.48c-.16.29-.4.58-.72.59-.57,0-.73-.76-.71-1.32a92.45,92.45,0,0,0-3-26"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.13,329.37a59.79,59.79,0,0,0,29.33,7.87,5.46,5.46,0,0,1,3.28.67c.91.67,1.16,2.31.17,2.86a2.47,2.47,0,0,1-1,.23,41.69,41.69,0,0,1-32.53-11.42"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M179.57,330.17c-.14,0,.52-10.44,1.49-23.29s1.86-23.28,2-23.27-.52,10.45-1.48,23.3S179.72,330.18,179.57,330.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,261.9a7,7,0,0,1,.28,1.45,24.31,24.31,0,0,1,.21,4,28.93,28.93,0,0,1-12,22.81,25.81,25.81,0,0,1-3.43,2.12,6.52,6.52,0,0,1-1.35.59,9.14,9.14,0,0,1,1.25-.77,33.15,33.15,0,0,0,3.31-2.23,29.94,29.94,0,0,0,11.83-22.53,33.27,33.27,0,0,0,0-4A9.44,9.44,0,0,1,105.13,261.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.43,266.13s.11.12.27.38a9.76,9.76,0,0,1,.65,1.15,17.08,17.08,0,0,1,1.44,4.66c.72,4.09.37,9.83-.74,16a34.74,34.74,0,0,1-2.72,8.43,23.88,23.88,0,0,1-4.1,6,18.25,18.25,0,0,1-3.78,3.08c-.5.28-.9.5-1.17.62a2,2,0,0,1-.43.17c0-.05.54-.33,1.49-1a20.75,20.75,0,0,0,3.62-3.16,24.15,24.15,0,0,0,3.94-5.92,35.77,35.77,0,0,0,2.64-8.32c1.1-6.11,1.5-11.82.89-15.84A20.51,20.51,0,0,0,112.43,266.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,278.29a16.69,16.69,0,0,0-4,.07,16.94,16.94,0,0,0-3.66,1.48s.25-.41.86-.85a7.37,7.37,0,0,1,5.62-1.14C125.72,278,126.13,278.23,126.11,278.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,274.14a17.82,17.82,0,0,1,1.29,1.65,47.26,47.26,0,0,0,3.73,4.31,27,27,0,0,0,6.68,5,17.69,17.69,0,0,0,9.9,2,17.44,17.44,0,0,0,9.32-3.88,17.16,17.16,0,0,0,4.88-6.7,18.24,18.24,0,0,0,1.3-5.5c.1-1.34,0-2.09.09-2.09a2.18,2.18,0,0,1,.07.54,11.31,11.31,0,0,1,.05,1.56,17.35,17.35,0,0,1-1.17,5.62,17.17,17.17,0,0,1-4.91,6.94,17.63,17.63,0,0,1-19.75,2,26.6,26.6,0,0,1-6.73-5.23,38.49,38.49,0,0,1-3.62-4.44c-.39-.55-.67-1-.86-1.3A2.59,2.59,0,0,1,126.43,274.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,297.61a19.32,19.32,0,0,0-5.35-.23,19.16,19.16,0,0,0-5.07,1.76,3.68,3.68,0,0,1,1.28-1,10.49,10.49,0,0,1,3.71-1.27,10.64,10.64,0,0,1,3.92.15A3.74,3.74,0,0,1,129,297.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,288.71c0,.06-.76-.1-2.1,0a14.81,14.81,0,0,0-5.44,1.6,56.9,56.9,0,0,0-7.13,4.62,32.19,32.19,0,0,1-4.36,2.6,25.66,25.66,0,0,1-5.15,1.79,35.92,35.92,0,0,1-10.47.75,59.46,59.46,0,0,1-8.47-1.25c-2.38-.5-4.28-1-5.6-1.34l-1.51-.42a2.21,2.21,0,0,1-.52-.18,2,2,0,0,1,.55.08l1.53.32c1.33.28,3.24.72,5.63,1.18a65.6,65.6,0,0,0,8.42,1.13,36,36,0,0,0,10.32-.78,25.9,25.9,0,0,0,5-1.74,32.16,32.16,0,0,0,4.31-2.54,53.3,53.3,0,0,1,7.24-4.55,14.41,14.41,0,0,1,5.59-1.48,9.36,9.36,0,0,1,1.57.08A2,2,0,0,1,180.45,288.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.37,282c-.09,0-.16-1.16-.57-3a23,23,0,0,0-7.33-12.34c-1.41-1.23-2.41-1.85-2.36-1.93a2.48,2.48,0,0,1,.74.37,13.75,13.75,0,0,1,1.86,1.28A20.9,20.9,0,0,1,184.17,279a15.49,15.49,0,0,1,.24,2.23A2.34,2.34,0,0,1,184.37,282Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.34,290.62a6.74,6.74,0,0,1,0-1.31c0-.84,0-2.05-.08-3.55a44,44,0,0,0-2-11.46,40.88,40.88,0,0,0-2.51-5.9,41.39,41.39,0,0,0-2.74-4.47c-1.74-2.44-3-3.8-2.93-3.87a6.44,6.44,0,0,1,.93.92,28.63,28.63,0,0,1,2.29,2.74,34.69,34.69,0,0,1,2.87,4.46,37.74,37.74,0,0,1,2.58,6,40.13,40.13,0,0,1,1.92,11.61,35.69,35.69,0,0,1-.09,3.57A6.07,6.07,0,0,1,195.34,290.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.25,313.56a6.87,6.87,0,0,1-.66.35,18.58,18.58,0,0,1-2,.8,29,29,0,0,1-7.74,1.39,104.31,104.31,0,0,1-11.66-.3c-2.18-.11-4.47-.19-6.84-.08a42.58,42.58,0,0,0-7.27,1c-4.92,1.08-9.56,2.5-14,3a50.85,50.85,0,0,1-11.67-.23c-3.3-.41-5.94-.92-7.76-1.27l-2.09-.43a4.36,4.36,0,0,1-.72-.18,3.71,3.71,0,0,1,.74.08l2.11.33c1.83.29,4.47.74,7.76,1.1a52.37,52.37,0,0,0,11.57.12c4.34-.48,9-1.91,13.91-3a42.23,42.23,0,0,1,7.35-1,68,68,0,0,1,6.9.11,111.8,111.8,0,0,0,11.61.42,31.35,31.35,0,0,0,7.7-1.22c.88-.27,1.56-.52,2-.71A3.5,3.5,0,0,1,179.25,313.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.35,336.51a10.1,10.1,0,0,1-1.69,0c-1.09,0-2.67,0-4.61,0a109.25,109.25,0,0,0-30,4.41c-1.86.54-3.37,1-4.4,1.35a11.57,11.57,0,0,1-1.63.48,9.78,9.78,0,0,1,1.56-.67c1-.4,2.51-.92,4.37-1.51a96.22,96.22,0,0,1,30.08-4.43c1.95,0,3.53.1,4.61.19A12,12,0,0,1,150.35,336.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,334a9.47,9.47,0,0,1-2.1,1.09,42.69,42.69,0,0,1-5.38,1.91,41.54,41.54,0,0,1-5.59,1.16,9.71,9.71,0,0,1-2.36.16,12.22,12.22,0,0,1,2.3-.52c1.42-.28,3.38-.71,5.51-1.3s4-1.25,5.38-1.75A12.18,12.18,0,0,1,179.32,334Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,351.76a5.31,5.31,0,0,1-.71.37c-.47.23-1.17.54-2.08.92a76.32,76.32,0,0,1-7.93,2.76,151.38,151.38,0,0,1-27.21,4.84,166.2,166.2,0,0,1-27.65.22c-3.53-.26-6.37-.59-8.34-.85l-2.25-.33a3.83,3.83,0,0,1-.78-.15,4.27,4.27,0,0,1,.79,0l2.27.23c2,.19,4.81.47,8.34.69a180.86,180.86,0,0,0,27.57-.38,162.67,162.67,0,0,0,27.16-4.67c3.41-.94,6.1-1.89,8-2.6l2.12-.83A5.63,5.63,0,0,1,188.45,351.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.68,378.16a51.87,51.87,0,0,0-7.12,0,50.77,50.77,0,0,0-7,1.48,6.23,6.23,0,0,1,1.92-.89,21.84,21.84,0,0,1,10.1-1A6.66,6.66,0,0,1,126.68,378.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.79,368.86c0,.15-1.8.15-4,.54s-3.86,1-3.91.85a12,12,0,0,1,7.88-1.39Z",
    style: {
      fill: "#fafafa"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.85c26baba38d6fc6ffad9523991f119b.svg";
export { ForwardRef as ReactComponent };